import { AppDispatch } from '@src/store/store'

import { setIsInitialized, setMessages } from '@src/store/ducks/app/reducer'
import { setIsAuth } from '@src/store/ducks/auth/reducer'
import { userApi } from '@src/api/user-api'
import { setUser } from '@src/store/ducks/user/reducer'
import { contactApi } from '@src/api/contact-api'

export const fetchMe = () => async (dispatch: AppDispatch) => {
  try {
    const result = await userApi.getMe()
    dispatch(setUser(result))
    dispatch(setIsAuth(true))
  } catch (err: any) {
    console.error(err)
    if (err?.response?.status === 401) {
      dispatch(setIsAuth(false))
    }
  } finally {
    dispatch(setIsInitialized())
  }
}

export const getMessages = () => async (dispatch: AppDispatch) => {
  try {
    const result = await contactApi.getMessages()
    dispatch(setMessages(result))
  } catch (err) {
    console.error(err)
  }
}
